import { Container, Title, Text, Stack, SimpleGrid } from '@mantine/core';
import { ProfileProvider, useVenueProfile } from './profile-context';
import { ZoneAvailability } from './components/ZoneAvailability';
import { TakeoutForm } from './components/TakeoutForm';

function PortalBody(): JSX.Element {
  const profile = useVenueProfile();
  const zones = profile.zones;
  const lineId = profile.capabilities.publicPortal.lineId;

  return (
    <Container size="md" py="xl">
      <Stack gap="lg">
        <div>
          <Title order={1}>{profile.branding.appTitle}</Title>
          <Text c="dimmed" size="lg">
            {profile.branding.tagline}
          </Text>
        </div>

        {zones.length === 0 && (
          <Text c="dimmed">目前沒有可用的場地區域</Text>
        )}

        <SimpleGrid cols={{ base: 1, sm: 2 }}>
          {zones.map((z) => (
            <ZoneAvailability
              key={z.serviceId}
              zone={{
                serviceId: z.serviceId,
                serviceName: z.name,
                resourceId: z.resourceId,
                scenarioType: z.scenarioType,
                zoneLabel: z.zoneLabel,
                minPartySize: z.minPartySize,
                maxPartySize: z.maxPartySize,
                totalUnits: z.capacity,
                unitCapacityMin: z.minPartySize,
                unitCapacityMax: z.maxPartySize,
                pricing: z.pricing,
              }}
              venueId={profile.venueId}
            />
          ))}
        </SimpleGrid>

        {profile.capabilities.publicPortal.showTakeoutForm && (
          <TakeoutForm venueId={profile.venueId} />
        )}

        {lineId && (
          <Text size="sm" c="dimmed" ta="center" mt="md">
            建議提前預約 · LINE ID {lineId}
          </Text>
        )}

        <Text size="xs" c="dimmed" ta="center" mt="xs">
          即時更新 — 實際可用性依現場為準
        </Text>
      </Stack>
    </Container>
  );
}

export function App(): JSX.Element {
  return (
    <ProfileProvider>
      <PortalBody />
    </ProfileProvider>
  );
}
